import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { IconBox } from '../../IconBox/index.js';

var checkIsFC = function (toBeDetermined) {
    return typeof toBeDetermined === "function" ? true : false;
};
var ButtonBody = function (_a) {
    var children = _a.children, iconLeft = _a.iconLeft, iconRight = _a.iconRight, size = _a.size;
    return (jsxs(Fragment, { children: [Boolean(iconLeft) &&
                (checkIsFC(iconLeft) ? (jsx(IconBox, { position: "left", icon: iconLeft, themeKey: "buttonIcons", size: size })) : (iconLeft)), children, Boolean(iconRight) &&
                (checkIsFC(iconRight) ? (jsx(IconBox, { position: "right", icon: iconRight, themeKey: "buttonIcons", size: size })) : (iconRight))] }));
};
ButtonBody.displayName = "ButtonBody";

export { ButtonBody };
//# sourceMappingURL=index.js.map
